import type {PointcloudLayer} from '../scene/layer';
import {touches,type XY} from './geometry';
export function candidateClouds(layers:PointcloudLayer[],ring:XY[]|null){return layers.filter(l=>{
  if(!ring)return true;const h=l.header;if(!h)return false;
  return touches({id:l.id,type:'polygon',parts:[[[h.min[0],h.min[1]],[h.max[0],h.min[1]],[h.max[0],h.max[1]],[h.min[0],h.max[1]],[h.min[0],h.min[1]]]],hasZ:false,props:{}},ring);
});}
export function saveBlob(name:string,contents:BlobPart,mime:string){
  const url=URL.createObjectURL(new Blob([contents],{type:mime}));const a=document.createElement('a');a.href=url;a.download=name;a.click();setTimeout(()=>URL.revokeObjectURL(url),30000);
}
export function csv(rows:Record<string,unknown>[]):string {
  const keys=[...new Set(rows.flatMap(Object.keys))];const cell=(value:unknown)=>{
    let s=typeof value==='object'&&value!==null?JSON.stringify(value):String(value??'');if(/^[=+@\-\t\r]/.test(s))s="'"+s;
    return '"'+s.replaceAll('"','""')+'"';
  };return [keys.map(cell).join(','),...rows.map(r=>keys.map(k=>cell(r[k])).join(','))].join('\r\n');
}
